module.exports = __webpack_public_path__ + "img/25a)Kanzleramt.jpg";